import {createRouter, createWebHistory} from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/home-view.vue')
  },
  {
    path: '/create-room',
    name: 'CreateRoom',
    component: () => import('../views/create-room.vue')
  },
  {
    path: '/c/:id',
    name: 'Chat',
    component: () => import('../views/chat-view.vue')
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('../views/error-view.vue')
  },
  {
    path: '/auth-failed',
    name: 'AuthFailed',
    component: () => import('../views/auth-failed.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
